import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from 'studio/components/TextField';
import UserChip from 'studio/components/Chip/UserChip/UserChip';
import Typography from '@mui/material/Typography';
import { getUserLabel } from 'utils/userRoleUtils';

const UserSelector = ({
  value,
  onChange,
  label,
  description,
  disabled = false,
  multiple = false,
  users,
  className,
  renderOption,
  placeholder,
  'data-test': dataTest,
  ...otherProps
}) => {
  const defaultRenderOption = (props, user) => {
    const { inputValue, ...domProps } = props;
    return (
      <li {...domProps}>
        <Typography
          component="div"
          style={{
            color: user.isDeleted ? '#666' : 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          {getUserLabel(user)}
          {user.isDeleted && (
            <Typography color="textSecondary" component="span">
              (deleted)
            </Typography>
          )}
        </Typography>
      </li>
    );
  };

  return (
    <Autocomplete
      multiple={multiple}
      value={value}
      options={users || []}
      onChange={onChange}
      getOptionLabel={getUserLabel}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderOption={renderOption || defaultRenderOption}
      filterSelectedOptions
      className={className}
      renderTags={(value, getTagProps) =>
        value.map((user, index) => <UserChip key={user.id} user={user} {...getTagProps({ index })} />)
      }
      renderInput={params => {
        // Remove inputValue from params to prevent it from being passed to the DOM
        const { inputValue, ...otherParams } = params;
        return (
          <TextField {...otherParams} label={label} description={description} placeholder={placeholder} size="small" />
        );
      }}
      disabled={disabled}
      data-test={dataTest}
      {...otherProps}
    />
  );
};

export default UserSelector;
